import React, {Fragment} from 'react'
import styled from 'styled-components'

import Bold from 'components/Bold'

const ErrorTitle = styled(Bold)`
  display: block;
  margin-bottom: 8px;
`

const ErrorText = ({error, description}) => (
  <Fragment>
    {error && <ErrorTitle>{error}</ErrorTitle>}
    {description}
  </Fragment>
)

export default ErrorText
